import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { Team } from 'dashboard/models/team';
import { setTeams } from 'dashboard/redux/actions/teams';
import { DashboardThunkAction } from 'dashboard/redux/types';
import { ApiEndpoint } from 'lib/interfaces/api';

export const loadTeams = (): DashboardThunkAction<Promise<void>> => async (dispatch) => {
  const { data: teams } = await SessionClientDashboard.listResource<Team>(ApiEndpoint.Team);
  dispatch(setTeams(teams));
};
